<template>
  <!-- School Condition and standard goes here -->
  <v-container fluid ma-0 pa-0 fill-height>
    <v-row justify="center" class="pa-1 ma-0">
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-text-field
          class="ttext my-1 px-1"
          outline
          placeholder="dd-mm-yyyy"
          :rules="[rules.declareDate]"
          v-model="compre_iden.oper_date"
          label="ថ្ងៃ ខែ ឆ្នាំ ដំណើរការ"
        />
      </v-col>
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-select
          class="px-1"
          v-model="compre_iden.supp_by"
          :items="sup_by"
          item-text="text"
          item-value="value"
          outline
          label="គាំទ្រដោយ"
          hide-details
          @keypress.native="onSelect3($event, index)"
        >
        </v-select>
      </v-col>
      <v-col xs12 sm3 md3 class="pa-0 ma-0">
        <v-select
          class="px-1"
          v-model="compre_iden.pre_stan"
          :items="std_pre"
          item-text="text"
          item-value="value"
          outline
          label="ជាមត្តេយ្យស្តង់ដា"
          hide-details
          @keypress.native="onSelect4($event, index)"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-divider class="pa-0 my-1"></v-divider>
    <v-row class="pa-0 ma-1">
      <v-col xs12 sm4 md4 class="pa-0 mx-1">
        <principle :data="sch_prin" :title="title[1]" />
      </v-col>
      <v-col xs12 sm4 md4 class="pa-0 mx-1">
        <schoolinfo :data="sch_iden" :info="compre_info" :title="title[2]" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import schoolInfo from "@/components/privateascf/compre/comPreSchoolInfo.vue";
import principle from "@/components/privateascf/compre/comPrePrinciple.vue";

import { sup_by, std_pre } from "@/utils/priascf/comPreVariables.js";

export default {
  props: ["title", "compre_iden", "sch_prin", "sch_iden", "compre_info"],
  components: {
    schoolinfo: schoolInfo,
    principle: principle,
  },
  data() {
    return {
      sup_by: sup_by,
      std_pre: std_pre,
      rules: {
        // :rules="[rules.required, rules.email]"
        required: (value) => !!value || "Required.",
        declareDate: (value) => {
          const pattern = /^(((((0[1-9])|(1\d)|(2[0-8]))-((0[1-9])|(1[0-2])))|((31-((0[13578])|(1[02])))|((29|30)-((0[1,3-9])|(1[0-2])))))-((20[0-9][0-9]))|(29-02-20(([02468][048])|([13579][26]))))$/;
          return pattern.test(value) || "សូមវាយទំរង់ dd-mm-yyyy";
        },
      },
    };
  },
  methods: {
    onSelect3: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 52) {
        this.compre_iden.supp_by = charCode - 48;
        this.$forceUpdate();
      }
    },
    onSelect4: function (event, index) {
      var charCode = event.keyCode;
      if (charCode >= 49 && charCode <= 51) {
        this.compre_iden.pre_stan = charCode - 48;
        this.$forceUpdate();
      }
    },
  },
};
</script>
<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
.input-group--select >>> .input-group__selections__comma {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 12px;
  padding: 1px 1px 1px 0;
}
</style>